import * as React from 'react';
import { cn, initials } from '@/lib/utils';

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  name: string;
  size?: 'sm' | 'md' | 'lg';
}

export function Avatar({ name, size = 'md', className, ...props }: AvatarProps) {
  const sizes = {
    sm: 'h-6 w-6 text-2xs',
    md: 'h-8 w-8 text-xs',
    lg: 'h-10 w-10 text-sm',
  };
  return (
    <div
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-800 font-semibold',
        sizes[size],
        className
      )}
      title={name}
      {...props}
    >
      {initials(name)}
    </div>
  );
}
